module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.editAction) ? _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        _vm.editAction(_vm.element)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "title": "Edit"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.deleteAction) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": function($event) {
        _vm.deleteAction(_vm.element)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "title": "Delete"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mailAction) ? _c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        _vm.mailAction(_vm.element)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "title": "Send Email"
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d93e503"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/ActionButtons.vue
// module id = 629
// module chunks = 1